import * as interestImageMap from '../img/interest';
import categoryMap from './categoryMap';

export default {
  art: {
    name: 'Art',
    image: interestImageMap.art,
    category: categoryMap.others,
  },
  baking: {
    name: 'Baking',
    image: interestImageMap.baking,
    category: categoryMap.food_and_beverage,
  },
  basketball: {
    name: 'Basketball',
    image: interestImageMap.basketball,
    category: categoryMap.outdoor_activities,
  },
  camping: {
    name: 'Camping',
    image: interestImageMap.camping,
    category: categoryMap.outdoor_activities,
  },
  farms: {
    name: 'Farms',
    image: interestImageMap.farms,
    category: categoryMap.outdoor_activities,
  },
  meditation: {
    name: 'Meditation',
    image: interestImageMap.meditation,
    category: categoryMap.others,
  },
  nature: {
    name: 'Nature',
    image: interestImageMap.nature,
    category: categoryMap.outdoor_activities,
  },
  photography: {
    name: 'Photography',
    image: interestImageMap.photography,
    category: categoryMap.landmarks,
  },
  skateboarding: {
    name: 'Skateboarding',
    image: interestImageMap.skateboarding,
    category: categoryMap.outdoor_activities,
  },
  travelling: {
    name: 'Travelling',
    image: interestImageMap.travelling,
    category: categoryMap.outdoor_activities,
  },
};
